import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive } from "vue";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; // 提交按钮文字


    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit; // 详情回显

    var list = reactive({
      rank: []
    }); //新增积分值

    function scoreRank() {
      return _scoreRank.apply(this, arguments);
    }

    function _scoreRank() {
      _scoreRank = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["scoreRank"]();

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                list.rank = data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _scoreRank.apply(this, arguments);
    }

    scoreRank();
    onMounted(function () {// 详情
    });
    return {
      submitText: submitText,
      list: list,
      scoreRank: scoreRank
    };
  }
});